import React from 'react';
import { Tag } from '../../atoms/Tag';
import { Typography } from '../Typography';
import { Button } from '../../atoms/Button';

interface ICardItem {
  id: string;
  isCurrent: boolean;
  title: string;
  date: string;
  link?: string;
  linkLabel?: string;
  currentLabel?: string;
  onClick?: () => void;
  onCardClick?: () => void;
  isLoading?: boolean;
}

export default function CourseWeekCard({
  id,
  title,
  date,
  link,
  linkLabel = 'Ver conteúdo',
  isCurrent,
  currentLabel = 'Semana Atual',
  onClick,
  onCardClick,
  isLoading = false,
}: ICardItem): React.JSX.Element {
  return (
    <div
      key={id}
      className='relative cursor-pointer mb-3 mt-3 min-w-[130px] max-w-fit rounded-lg bg-color-lightest transition-colors duration-150 hover:bg-color-lighter
               px-3 py-4 text-center shadow-level-1 xs:mx-auto'
      onClick={onCardClick}
    >
      {isCurrent && (
        <Tag
          variant='primary'
          className='absolute -top-3 left-1/2 grid w-8/12  max-w-full -translate-x-1/2 place-items-center'
        >
          {currentLabel}
        </Tag>
      )}

      <Typography size='h4' weight='bold' type='title'>
        {title}
      </Typography>
      <Typography size='mini' className='text-mono-color-darker'>
        {date}
      </Typography>

      <Button
        allowReadOnly
        size='small'
        variant='text'
        asLink={!!link}
        to={link}
        loading={isLoading}
        onClick={(event) => {
          event.stopPropagation();
          onClick?.();
        }}
        full
        className='my-1'
      >
        {linkLabel}
      </Button>
    </div>
  );
}
